import React from "react";
import { Bell, BellOff } from "lucide-react";
import usePush from "../lib/usePush";

export default function NotificationBell() {
  const { supported, subscribed, busy, enable, disable } = usePush();
  if (!supported) return null;
  return (
    <button
      onClick={subscribed ? disable : enable}
      disabled={busy}
      data-testid="notification-toggle"
      title={subscribed ? "Turn off notifications" : "Turn on notifications for new posts"}
      className="p-2 rounded-full text-[#615A50] hover:text-[#3D5844] hover:bg-[#E7DFCE] transition-colors disabled:opacity-50"
    >
      {subscribed ? <Bell className="w-5 h-5 text-[#3D5844]" /> : <BellOff className="w-5 h-5" />}
    </button>
  );
}
